import { render } from "./RmaElement.vue?vue&type=template&id=30117446&scoped=true&ts=true&lang=pug"
import script from "./RmaElement.vue?vue&type=script&lang=ts"
export * from "./RmaElement.vue?vue&type=script&lang=ts"

import "./RmaElement.vue?vue&type=style&index=0&id=30117446&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30117446"]])

export default __exports__